import React, { useEffect, useState } from 'react'
import TextField from "@material-ui/core/TextField";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { interviewOption } from "../JobInputData";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { getallReguser } from "../../features/Registration/registrationSlice";
import { Spinners } from "../TableOptions";
import { applicationInterview, reset } from "../../features/Applicant/applicantSlice";
import swal from 'sweetalert';
import { useNavigate } from "react-router-dom";
import ModalHeader from '../ModalHeader';

const InterviewModal = ({ title, nametitle, id, name, ids }: any) => {

	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { dataAll } = useAppSelector((state: { registration: any; }) => state.registration)
	const { applicationInterviewisError, applicationInterviewmessage, applicationInterviewisLoading, applicationInterviewisSuccess } = useAppSelector((state: { applicant: any; }) => state.applicant)


	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	useEffect(() => {
		if (show) {
			dispatch(getallReguser());
		}
	}, [dispatch, show]);

	const [inputs, setInputs] = useState({
		recruiterID: "",
		comment: "",
		interviewStatus: "",
		applicationIds: null
	});





	useEffect(() => {
		if (applicationInterviewisError) {
			swal({
				title: "error",
				text: applicationInterviewmessage,
				icon: "error"
			})
		} else if (applicationInterviewisSuccess) {
			swal({
				title: "success",
				text: "Applicant Sent For Interview!",
				icon: "success"
			})
			setShow(false)
			setInputs(
				{
					recruiterID: "",
					comment: "",
					interviewStatus: "",
					applicationIds: null
				}
			)
		}
		dispatch(reset())
	}, [applicationInterviewisError, applicationInterviewisSuccess, applicationInterviewmessage, dispatch, navigate])





	const handleOnChange = (input: any, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};

	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				applicationIds: id? [id] :ids,
			});
		});
	}, [setInputs, id, ids]);




	const handleScreening = () => {
		// @ts-ignore
		dispatch(applicationInterview(inputs));
	}

	return (
		<>
			<div onClick={handleShow} className="more-button">
				{title}
			</div>

			<Modal show={show} onHide={handleClose}>
				<ModalHeader setShow={setShow} headerTitle={"Send for Interview"} />
				<Modal.Body>
					<form>
						<div className="applicant-name">
							<h5>Applicant Name</h5>
							{Array.isArray(name) ? name.slice(0, 2)?.map((item) => (
                <p key={item?.id}>{`${item?.title} ${item?.firstName} ${item?.middleName} ${item?.LastName}`}</p>
              )) : null}
              {name?.length > 2 && <p>...</p>}
						</div>
						<br />
						<div className="reviewer-name">
							<h6>Reviewer</h6>
							<select
								className="round"
								onChange={(e) => handleOnChange("recruiterID", e.target.value)}
							>

								<option>Select Reviewer</option>
								{dataAll?.data?.map((item: any) => (
									<option key={item?.id} value={item?.id} >
										{item?.firstName + " " + item?.LastName}
									</option>
								))}
							</select>


							<h6 className="mt-4">Screening Options</h6>
							<select
								className="round"
								value={inputs.interviewStatus}
								onChange={(e) => handleOnChange("interviewStatus", e.target.value)} >

								<option>Select Options</option>
								{interviewOption?.map((item: any, i: any) => (
									<option key={i} value={"PENDING"}>
										{item}
									</option>
								))}
							</select>


							<div className="comment mt-4">
								<h6>Comment</h6>
								<TextField
									id="outlined-multiline-static"
									multiline
									fullWidth
									type="text"
									minRows={4}
									variant="outlined"
									style={{ margin: "10px 0" }}
									value={inputs.comment}
									onChange={(e) => handleOnChange("comment", e.target.value)}
								/>
							</div>
						</div>

					</form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Cancel
					</Button>
					<Button id="primary" onClick={handleScreening}>
						{applicationInterviewisLoading ? <Spinners size={"sm"} /> : 'Send'}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default InterviewModal
